
<div class="dropzone-container">
<div
    class="dropzone dz-wrapper"
    #dropzone="ngxDropzone"
    [dropzone]="dropzoneConfig"
    (error)="dropzoneError($event)"
    (success)="dropzoneSuccess($event)"
    (uploadProgress)="dropzoneUploadProcess($event)"
    (addedFile)="dropzoneAddedFile($event)"
    (queueComplete)="onDropzoneQueueComplete($event)"
>
    <div class="dz-message">
        <div class="dz-text">{{ dropzoneConfig.dictDefaultMessage }}</div>

    </div>

</div>
    <button app-button class="mobilePhotoButton" type="button" (click)="triggerFileInput()">
        <fa-icon icon="camera"></fa-icon>
    </button>
</div>
<ng-template #deleteButton>
    <button app-round-button Color="red" class="delete-button"><fa-icon icon="trash"></fa-icon></button>
</ng-template>
<input #fileInput type="file" id="picture" name="picture" accept="image/*" capture="environment" hidden (change)="onFileSelected($event)" />
